// KeyPointAlongSideComponent.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import ScrollFadeWrapper, {
  ScrollFadeSection,
} from '../../ScrollFadeWrapper/ScrollFadeWrapper';
import Image from '../../Image/Image';

const KEYPOINT_VECTOR_URL =
  'https://assets.askhippo.co.za/Vectors/KeyPointVerticalVector.svg';

const KeyPointAlongSideComponent = ({ data }) => {
  const { title, description, footer, steps } = data;

  return (
    <ScrollFadeSection
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        marginLeft: '-40px',
      }}
    >
      {/* ensure children don't stretch vertically */}
      <Box sx={{ width: '1100px', display: 'flex', alignItems: 'flex-start' }}>
        {/* Sticky Blue Box */}
        <Box
          sx={{
            position: 'sticky',
            top: '120px',
            width: '390px',
            backgroundColor: '#162F3B',
            borderRadius: '64px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            boxSizing: 'border-box',
            padding: '40px',
            zIndex: 2,
            flexShrink: 0,
            marginTop: '40px',
            marginRight: '-24px',
            alignSelf: 'flex-start',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: '3rem',
              lineHeight: '3.5rem',
              color: '#FFFFFF',
              mb: description || footer ? '32px' : '0px',
              maxWidth: '310px',
              textAlign: 'center',
              whiteSpace: 'pre-line',
            }}
          >
            {title}
          </Typography>

          {description && (
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: '1.5rem',
                lineHeight: '1.75rem',
                color: '#FFFFFF',
                mb: '32px',
                textAlign: 'center',
                whiteSpace: 'pre-line',
              }}
            >
              {description}
            </Typography>
          )}

          {footer && (
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 600,
                fontSize: '0.75rem',
                lineHeight: '1.25rem',
                color: '#FFFFFF',
                textAlign: 'center',
              }}
            >
              {footer}
            </Typography>
          )}
        </Box>

        {/* Right Column */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '40px',
            width: '700px',
            paddingTop: '40px',
            paddingRight: '80px',
            paddingLeft: '40px',
            paddingBottom: 0,
            borderRadius: '48px',
            boxSizing: 'border-box',
          }}
        >
          {steps.map(({ number, title, text }, index) => (
            <ScrollFadeWrapper key={index} delay={index * 0.1}>
              <Box
                sx={{
                  width: '700px',
                  backgroundColor: '#FFFFFF',
                  borderRadius: '64px',
                  padding: '40px',
                  boxSizing: 'border-box',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '40px',
                  boxShadow:
                    '0px 1px 2px 0px #A2ACB133, 0px 12px 24px -4px #162F3B1F',
                }}
              >
                <Box
                  sx={{ position: 'relative', width: '104px', height: '104px' }}
                >
                  <Image
                    width={104}
                    height={104}
                    src={KEYPOINT_VECTOR_URL}
                    alt="Key point illustration (vertical)"
                    sx={{ width: '100%', height: '100%' }}
                  />
                  <Typography
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      fontFamily: 'Pally, Inter',
                      fontWeight: 700,
                      fontSize: '3rem',
                      color: '#162F3B',
                    }}
                  >
                    {number}
                  </Typography>
                </Box>

                <Box sx={{ maxWidth: '440px' }}>
                  <Typography
                    sx={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 700,
                      fontSize: '1.5rem',
                      lineHeight: '1.75rem',
                      color: '#162F3B',
                      mb: '16px',
                    }}
                  >
                    {title}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: '1rem',
                      lineHeight: '1.5rem',
                      color: '#162F3B',
                      whiteSpace: 'pre-line',
                    }}
                  >
                    {text.split(/(\*\*[^*]+\*\*)/g).map((part, i) => {
                      if (/^\*\*[^*]+\*\*$/.test(part)) {
                        return (
                          <strong key={i} style={{ fontWeight: 700 }}>
                            {part.slice(2, -2)}
                          </strong>
                        );
                      }
                      return part;
                    })}
                  </Typography>
                </Box>
              </Box>
            </ScrollFadeWrapper>
          ))}
        </Box>
      </Box>
    </ScrollFadeSection>
  );
};

export default KeyPointAlongSideComponent;
